// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"641":"1b341e41","1029":"8715058c","2448":"8668f483","2835":"91ac0ced","5653":"e664e4bc","8502":"5fd9f693","9832":"60ead15c"}[chunkId] + ".chunk.css";
};